import { HelmetProvider } from 'react-helmet-async';
import { rootContainer } from '@mobx/root';
import { NotistackProvider } from '@shared/utils/notifications';
import { observer } from 'mobx-react-lite';
import { Provider as DIProvider } from 'inversify-react';
import RtlLayout from '@shared/components/RtlLayout';
import { queryClient } from '@shared/api/reactQuery';
import { QueryClientProvider } from '@tanstack/react-query';
import { CollapseDrawerProvider } from '@shared/theme/themeSettings/context/CollapseDrawerContext';
import { AppThemeProvider } from '@shared/theme/themeSettings/context/AppThemeContext';
import { type ReactNode } from 'react';
import { LanguageConfig } from './languageConfig';
import { DateTimeLocalizationProvider } from './DateTimeLocalizationProvider';

// TODO: перенести Instructions на самый верхний уровень - чтобы был доступен между страницами

interface Props {
  children: ReactNode;
}

export const Providers: React.FC<Props> = observer(({ children }) => (
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <DIProvider container={rootContainer}>
        <AppThemeProvider>
          <CollapseDrawerProvider>
            <RtlLayout>
              <NotistackProvider autoHideDuration={1500}>
                <LanguageConfig>
                  <DateTimeLocalizationProvider>{children}</DateTimeLocalizationProvider>
                </LanguageConfig>
              </NotistackProvider>
            </RtlLayout>
          </CollapseDrawerProvider>
        </AppThemeProvider>
      </DIProvider>
    </QueryClientProvider>
  </HelmetProvider>
));
